import React, { useEffect, useState } from 'react';
// @ts-ignore
import { adminWebUrl } from '../../environment/environment';
import { Button, Col, Form, Input, Radio, Row, Select, Checkbox, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { businessCategories, socialMediaList } from '@constants/map';
import LabelWithToolTip from '@components/Comman/LabelWithToolTip/LabelWithToolTip';
import { getReferrerDetailsAction } from '../../actions/user';
import { getQueryValue } from '@utils/common/common';
import CustomPhoneNumber from '@components/Comman/CustomPhoneNumber/CustomPhoneNumber';
import { getAllBusinessCategories } from '../../actions/business';

const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const RegisterFrom = ({ handleSubmit, userData }: any) => {
    const [componentDisabled] = useState<boolean>(false);
    const [termsAndCondition, setTermsAndCondition] = useState(false)
    const [selectedSocialMedia, setSelectedSocialMedia] = useState<string[]>([]);
    const [socialMediaUrls, setSocialMediaUrls] = useState<{ [key: string]: string }>({});
    const urlPattern = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.[a-zA-Z]{2,})(\/[^\s]*)?$/;
    let id = getQueryValue('id')

    const [isOtherSelected, setIsOtherSelected] = useState(false);
    const [businessCategory, setBusinessCategory] = useState([])
    const [abn, setAbn] = useState("")
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const getReferrerDetails = async () => {
        let payloadData = {
            id: id
        }
        await dispatch(
            getReferrerDetailsAction(payloadData, (resp: any) => {
                // Set form field values when userData changes
                form.setFieldsValue({
                    companyName: resp?.data?.companyName,
                    abn: resp?.data?.abn,
                    email: resp?.data?.email,
                    contact: `${resp?.data?.firstName} ${resp?.data?.lastName}`,    
                    mobileNumber: resp?.data?.mobileNumber,
                    address: resp?.data?.address,
                    socialMediaSelection: resp?.data?.socialMediaUrl,
                });
            })
        );
    }
    useEffect(()=> {
        dispatch(getAllBusinessCategories({}, (res:any)=> setBusinessCategory(res?.data)))
    }, [])
    useEffect(()=> {
        if(id) {
            getReferrerDetails()
        }
    }, [id])


    const onFinish = (values: any) => {
        const transformedData = transformUrls();
        const payload = {
            companyName: values?.companyName,
            contactName: values?.contact,
            abn: values?.abn,
            position: values?.position,
            email: values?.email,
            mobileNumber: values?.mobileNumber,
            contactNumber: values?.contactNumber,
            address: values?.address,
            businessCategory: values?.businessCategory === "other" ? values?.otherBusinessCategory : values?.businessCategory,
            socialMediaUrl: transformedData,
            yearly: false,
            monthly: true,

            termsAndConditions: values?.termsAndConditions,
        };
        handleSubmit(payload)

    };
    const onFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
        // You can also display an error message to the user here
    };


    const handleAbnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAbn(e.target.value);
    };

    const handleSelectSocial = (value: string[]) => {
        setSelectedSocialMedia(value);
    };
    const handleUrlChange = (platform: string, url: string) => {
        setSocialMediaUrls((prev) => ({
            ...prev,
            [platform]: url,
        }));
    };



    const handleCategoryChange = (value: string) => {
        if (value === 'other') {
            setIsOtherSelected(true);
        } else {
            setIsOtherSelected(false);
        }
    };

    const transformUrls = () => {
        const result: { [key: string]: string } = {};
        selectedSocialMedia.forEach((platform) => {
            const urlKey = `socialMediaSelection_${platform}`;
            if (socialMediaUrls[platform]) {
                result[platform] = socialMediaUrls[platform]; // Use the platform as key and its URL as value
            }
        });
        return result;
    };

    // ** Tooltip state to activate at a time *************** //
    const [tooltipVisible, setTooltipVisible] = useState<any>({
        'business': false,
        'abn': false,
        'email': false,
        'contactPerson': false,
        'position': false,
        'mobile': false,
        'phone': false,
        'address': false,
        'category': false,
        'socialMedia': false
    });

    return (
        <div className=''>
            <Row>
                <Col lg={24} md={24} sm={24}>
                    <Form className='formControl'
                        layout="vertical"
                        form={form}
                        {...layout}
                        disabled={componentDisabled}
                        onFinish={onFinish}
                        onFinishFailed={onFailed}
                        initialValues={{
                            ...userData,
                            companyName: userData?.companyName,
                            abn: userData?.abn,
                            email: userData?.email,
                            contactName: userData?.contactName,
                            contact: userData?.contactName,
                            socialMediaSelection: userData?.socialMediaUrl
                        }}
                    >
                        <Form.Item
                        name="companyName"
                        className="formControlDesign"
                        label={<LabelWithToolTip titleKey='business' visible={tooltipVisible} setVisible={setTooltipVisible} label='Business Name' title={`A mandatory field as the company name is important throughout the entire system. If you are part of a business chain or franchise, enter the name and then enter your branch. i.e.: Super Cheap Auto - BlackTown`} />}
                        rules={[
                            {
                            required: true,
                            message: 'Please input your business name!',
                            },
                        ]}
                        >
                            <Input placeholder="Business Name" />
                        </Form.Item>

                        <Form.Item
                            name="abn"
                            className='formControlDesign'
                            label={<LabelWithToolTip titleKey='abn' visible={tooltipVisible} setVisible={setTooltipVisible} label='ABN' title={`A non-mandatory field. This is a business identification in Australia`} />}
                        >
                            <Input placeholder='ABN' value={abn} onChange={handleAbnChange} />
                        </Form.Item>
                        <Form.Item
                            name="email"
                            className='formControlDesign'
                            label={<LabelWithToolTip titleKey='email' visible={tooltipVisible} setVisible={setTooltipVisible} label='Email Address' title={`Mandatory field as this is how not only we communicate with you but your referrers and referrals`} />}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your email!',
                                },
                                {
                                    type: 'email',
                                    message: 'The input is not valid E-mail!',
                                },
                            ]}
                        >
                            <Input placeholder='Email Address' />
                        </Form.Item>
                        <Form.Item
                            name="contact"
                            className='formControlDesign'
                            label={<LabelWithToolTip titleKey='contactPerson' visible={tooltipVisible} setVisible={setTooltipVisible} label='Contact Person' title={`The main person using ReferUs`} />}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input contact person!',
                                }
                            ]}
                        >
                            <Input placeholder='Contact Person ' />
                        </Form.Item>
                        <Form.Item
                            name="position"
                            className='formControlDesign'
                            label={<LabelWithToolTip titleKey='position' visible={tooltipVisible} setVisible={setTooltipVisible} label='Contact Person Position' title={`Non-mandatory but may come in handy in a future update to complete this field`} />}
                        >
                            <Input placeholder='Contact Person Position' />
                        </Form.Item>

                        
                        <CustomPhoneNumber 
                          isRequired={true} 
                          isToolTip={true} 
                          label={<LabelWithToolTip titleKey='mobile' visible={tooltipVisible} setVisible={setTooltipVisible} label={<span><span style={{ color: "#ff4d4f", fontSize: '14px' }}>*</span> Contact Number (This can be business or mobile number)</span>} title={`Mandatory field so the system can be opened up on your mobile phone.`} />} 
                          name="mobileNumber" 
                          />
                        
                        {/* <CustomPhoneNumber 
                          isRequired={false} 
                          isToolTip={true} 
                          label={<LabelWithToolTip titleKey='phone' visible={tooltipVisible} setVisible={setTooltipVisible} label={<span>Company Phone Number (Including area code)</span>} title={`Non-mandatory field but it would good to have as the system creates a promotion page for your business that is used to post on social media. So having your company number is a good idea.`} />} 
                          name="contactNumber" 
                          /> */}
                       
                        <Form.Item 
                            name="address" 
                            className='formControlDesign'
                            label={<LabelWithToolTip titleKey='address' visible={tooltipVisible} setVisible={setTooltipVisible} label='Address' title={`A non mandatory field. But as per the company phone number. The system automatically creates. A promotional page. For your business And this address will be on that page.`} />}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input Address',
                                }
                            ]}
                        >
                            <Input placeholder='Address' />
                        </Form.Item>
                        <Form.Item
                            className='formControlDesign business-category'
                            name="businessCategory"
                            label={
                                <LabelWithToolTip
                                    titleKey='category'
                                    visible={tooltipVisible}
                                    setVisible={setTooltipVisible}
                                    label='Business Category'
                                    title={`A mandatory field. As throughout the system. You'll be able to search by categories. If your category is not there select other And into your category.`}
                                />
                            }
                            rules={[
                                {
                                    required: true,
                                    message: 'Please select a business category!',
                                }
                            ]}
                        >
                            <Select
                                placeholder="Select a Business Category" // Updated placeholder text for clarity
                                onChange={handleCategoryChange}
                                value={userData?.businessCategory}
                                showSearch
                                allowClear // Optional: Allows users to clear the selection
                                filterOption={(input:any, option:any) =>
                                    option.children.toLowerCase().includes(input.toLowerCase())
                                }
                            >
                                <Select.Option>Select or Search business categories</Select.Option>
                                {businessCategory?.map((item, index) => (
                                    <Select.Option key={index} value={item?.value}>
                                        {item?.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <div>

                            {isOtherSelected && (
                                <Form.Item
                                    name="otherBusinessCategory" // Updated to use the same name
                                    // label="Please specify Category"
                                    className='formControlDesign'
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please specify your business category!',
                                        },
                                    ]}
                                >
                                    <Input placeholder="Specify other business category" />
                                </Form.Item>
                            )}
                        </div>
                        <Form.Item
                            name="socialMedia"
                            label={<LabelWithToolTip titleKey='socialMedia' visible={tooltipVisible} setVisible={setTooltipVisible} label='Social Media' title={`You can select more than one social media type as the system will automatically create a unique URL for your promotional page to post on your social media . Throughout the system the social media platforms that you have selected will be seen at the top of the page.`} />}
                            style={{paddingTop: '10px'}}
                        >
                            <Select
                                mode="multiple"
                                placeholder="Select Social Media"
                                onChange={handleSelectSocial}
                                size='large'
                            >
                                {socialMediaList.map((item, index) => (
                                    <Select.Option key={index} value={item.value}>
                                        {item.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        {selectedSocialMedia.map((platform: any) => (
                            <div key={platform} className="socialmedias">
                                <div className="socialicons">
                                    {platform === 'facebook' && <svg xmlns="http://www.w3.org/2000/svg" width="12" height="22" viewBox="0 0 12 22" fill="none">
                                        <path d="M7.98017 21.4074V11.805H11.202L11.6854 8.06171H7.98017V5.67213C7.98017 4.58869 8.2798 3.85034 9.83522 3.85034L11.8158 3.84952V0.501355C11.4733 0.456845 10.2976 0.354797 8.92914 0.354797C6.07167 0.354797 4.11539 2.09897 4.11539 5.3014V8.06171H0.883789V11.805H4.11539V21.4074H7.98017Z" fill="#F47523" />
                                    </svg>}
                                    {platform === 'instagram' && <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                        <path d="M20.9796 6.17406C20.9304 5.05825 20.75 4.29114 20.4915 3.62643C20.2249 2.92085 19.8146 2.28915 19.2772 1.76402C18.752 1.23071 18.1162 0.816306 17.4188 0.553819C16.7502 0.295338 15.9871 0.114898 14.8713 0.0657019C13.7472 0.0123391 13.3903 0 10.5391 0C7.68801 0 7.33113 0.0123391 6.21116 0.0615355C5.09535 0.110732 4.32824 0.291332 3.66369 0.549653C2.95796 0.816306 2.32626 1.22654 1.80112 1.76402C1.26782 2.28915 0.853575 2.92502 0.590928 3.62242C0.332447 4.29114 0.152007 5.05408 0.102811 6.16989C0.0494485 7.29403 0.0371094 7.65091 0.0371094 10.5021C0.0371094 13.3532 0.0494485 13.7101 0.0986447 14.83C0.147841 15.9459 0.328441 16.713 0.586921 17.3777C0.853575 18.0833 1.26782 18.7149 1.80112 19.2401C2.32626 19.7734 2.96212 20.1878 3.65952 20.4503C4.32824 20.7088 5.09118 20.8892 6.20715 20.9384C7.32697 20.9878 7.684 20.9999 10.5351 20.9999C13.3863 20.9999 13.7431 20.9878 14.8631 20.9384C15.9789 20.8892 16.746 20.7088 17.4106 20.4503C18.8219 19.9046 19.9377 18.7888 20.4834 17.3777C20.7417 16.709 20.9223 15.9459 20.9715 14.83C21.0207 13.7101 21.033 13.3532 21.033 10.5021C21.033 7.65091 21.0288 7.29403 20.9796 6.17406ZM19.0886 14.748C19.0434 15.7736 18.8711 16.3274 18.7275 16.6966C18.3746 17.6115 17.6486 18.3376 16.7337 18.6904C16.3645 18.834 15.8067 19.0063 14.7851 19.0513C13.6774 19.1007 13.3453 19.1128 10.5433 19.1128C7.74137 19.1128 7.40501 19.1007 6.30138 19.0513C5.27579 19.0063 4.72197 18.834 4.35276 18.6904C3.89749 18.5222 3.48309 18.2555 3.14673 17.9068C2.79803 17.5663 2.53137 17.1561 2.36311 16.7008C2.21953 16.3316 2.04726 15.7736 2.00223 14.7522C1.95288 13.6445 1.9407 13.3122 1.9407 10.5102C1.9407 7.70828 1.95288 7.37192 2.00223 6.26844C2.04726 5.24285 2.21953 4.68903 2.36311 4.31982C2.53137 3.86439 2.79803 3.45015 3.15089 3.11363C3.49126 2.76493 3.9015 2.49828 4.35692 2.33017C4.72614 2.18659 5.28412 2.01432 6.30554 1.96913C7.41318 1.91994 7.74554 1.9076 10.5473 1.9076C13.3534 1.9076 13.6856 1.91994 14.7893 1.96913C15.8148 2.01432 16.3687 2.18659 16.7379 2.33017C17.1931 2.49828 17.6075 2.76493 17.9439 3.11363C18.2926 3.45416 18.5593 3.86439 18.7275 4.31982C18.8711 4.68903 19.0434 5.24686 19.0886 6.26844C19.1377 7.37608 19.1501 7.70828 19.1501 10.5102C19.1501 13.3122 19.1377 13.6404 19.0886 14.748Z" fill="#F47523" />
                                        <path d="M10.5391 5.10748C7.56092 5.10748 5.14453 7.52371 5.14453 10.5021C5.14453 13.4805 7.56092 15.8967 10.5391 15.8967C13.5175 15.8967 15.9337 13.4805 15.9337 10.5021C15.9337 7.52371 13.5175 5.10748 10.5391 5.10748ZM10.5391 14.0014C8.60702 14.0014 7.03979 12.4344 7.03979 10.5021C7.03979 8.56981 8.60702 7.00274 10.5391 7.00274C12.4714 7.00274 14.0385 8.56981 14.0385 10.5021C14.0385 12.4344 12.4714 14.0014 10.5391 14.0014V14.0014Z" fill="#F47523" />
                                        <path d="M17.4067 4.89413C17.4067 5.58961 16.8427 6.15353 16.1471 6.15353C15.4516 6.15353 14.8877 5.58961 14.8877 4.89413C14.8877 4.19849 15.4516 3.63474 16.1471 3.63474C16.8427 3.63474 17.4067 4.19849 17.4067 4.89413V4.89413Z" fill="#F47523" />
                                    </svg>}
                                    {platform === 'linkedin' && <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                        <g clip-path="url(#clip0_730_815)">
                                            <path d="M20.9946 21V20.9992H20.9999V13.2974C20.9999 9.52966 20.1888 6.62729 15.784 6.62729C13.6665 6.62729 12.2455 7.78929 11.6654 8.89091H11.6041V6.97904H7.42773V20.9992H11.7765V14.0569C11.7765 12.229 12.123 10.4615 14.3866 10.4615C16.617 10.4615 16.6503 12.5475 16.6503 14.1742V21H20.9946Z" fill="#F47523" />
                                            <path d="M0.34668 6.97986H4.70068V21H0.34668V6.97986Z" fill="#F47523" />
                                            <path d="M2.52175 0C1.12963 0 0 1.12963 0 2.52175C0 3.91387 1.12963 5.06712 2.52175 5.06712C3.91387 5.06712 5.0435 3.91387 5.0435 2.52175C5.04262 1.12963 3.913 0 2.52175 0V0Z" fill="#F47523" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_730_815">
                                                <rect width="21" height="21" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>}
                                </div>
                                <Form.Item
                                    name={`socialMediaSelection_${platform}`} // Unique name for each input
                                    className='formControlDesign'
                                    rules={[
                                        {
                                            pattern: urlPattern,
                                            message: 'Please enter a valid URL!',
                                        },
                                    ]}
                                >
                                    <Input
                                        placeholder={`${platform.charAt(0).toUpperCase() + platform.slice(1)} URL`}
                                        onChange={(evt) => handleUrlChange(platform, evt.target.value)}
                                    />
                                </Form.Item>
                            </div>
                        ))}

                        <Form.Item
                            name="termsAndConditions"
                            className='formControlDesign'
                            valuePropName="checked"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please accept terms and conditions!',
                                }
                            ]}
                        >
                            <Checkbox className='checkBoxdesign' defaultChecked={termsAndCondition} onChange={(evt: any) => console.warn(evt.target.checked)}>I agree to <a href="/terms-and-conditions" style={{color:"#F47523"}} target="_blank"><u>Terms and Conditions</u></a></Checkbox>
                        </Form.Item>

                        <Col lg={24} style={{ marginBottom: '20px', textAlign: 'center' }}>
                            <span 
                                style={{cursor: 'pointer', color: '#F47523', fontSize: '16px'}} 
                                onClick={()=> window.open(`${adminWebUrl}/login`,'_self')}>
                                    Already have an account? Login
                            </span>
                        </Col>
                        <Button className='btn btn-primary w-100' type="primary" onClick={() => form.submit()}>
                            Next
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    );
};

export default RegisterFrom;
